module.exports = __webpack_public_path__ + "img/36.15cb7777.png";